import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {CustomLogoComponent} from './custom-logo.component';
import {CmsConfig, ConfigModule, UrlModule} from '@spartacus/core';
import {RouterModule} from '@angular/router';
import {CustomIconsModule} from '../../../icons/custom-icons.module';


@NgModule({
  declarations: [CustomLogoComponent],
  exports: [
    CustomLogoComponent
  ],
  imports: [
    CommonModule,
    ConfigModule.withConfig({
      cmsComponents: {
        LogoOhgarComponent: {
          component: CustomLogoComponent,
        },
      },
    } as CmsConfig),
    RouterModule,
    UrlModule,
    CustomIconsModule,
  ]
})
export class CustomLogoModule { }
